const trashIcon = `
<svg xmlns="http://www.w3.org/2000/svg" width="20" height="22" viewBox="0 0 20 22">
  <g fill="none" fill-rule="evenodd" transform="translate(0 1)">
    <g class="icon-trash" stroke="#C9CCCD" stroke-linecap="round" stroke-linejoin="round" transform="translate(.833)">
      <rect width="13.333" height="16.667" x="2.083" y="2.917"/>
      <rect width="6.667" height="2.5" x="5.417" y=".417"/>
      <path d="M0 2.91666667L18.3333333 2.91666667M5.41666667 5.83333333L5.41666667 15.8333333M8.75 5.83333333L8.75 15.8333333M12.0833333 5.83333333L12.0833333 15.8333333"/>
    </g>
    <rect width="20" height="20"/>
  </g>
</svg>
    `;

export default trashIcon;
